<template>
  <div class="row">

    <div class="col-12 mt-3" v-if="measurements.length">

      <line-chart v-if="lineChartDataset"
                  v-bind:datasets="lineChartDataset"
                  v-bind:show-legend="false"
                  :withoutMax=true
                  :animation-duration=0
                  :aspect-ratio=false
                  :height="360"
                  :width=null
                  chartId="averageBehavior"
                  :scale-label= "'behavior.average_behavior' | trans"
                  v-bind:y-axes-begin-at-zero="true"/>
      <h4 class="chart__title mb-3">{{'behavior.unwanted_behavior_chart' | trans}}</h4>

    </div>

    <div class="col-12">
      <div class="row mt-5">
        <div class="col-md-6 col-sm-12" :class="{'col-lg-4': isClient}" v-if="antecedentTypes">
          <h5>{{'behavior.ancedent' | trans }}</h5>
          <bar-chart :bardatasets="barChartAncedentDataset"
                     v-bind:show-legend="false" :height="260"/>
          <div v-for="label in barChartAncedentDataset"
               class="legend-item"><span
              :style="{background:label.backgroundColor}"></span>{{label.label}}
          </div>
        </div>
        <div class="col-md-6 col-sm-12" :class="{'col-lg-4': isClient}" v-if="behaviorTypes">
          <h5>{{'behavior.unwanted_behavior' | trans }}</h5>

          <bar-chart :bardatasets="barChartBehaviorDataset"
                     v-bind:show-legend="false" :height="260"/>
          <div v-for="label in barChartBehaviorDataset"
               class="legend-item"><span
              :style="{background:label.backgroundColor}"></span>{{label.label}}
          </div>
        </div>
        <div class="col-md-6 col-sm-12 pt-md-2" :class="{'col-lg-4': isClient}" v-if="effectsTypes">
          <h5>{{'behavior.ub_environment' | trans }}</h5>

          <bar-chart :bardatasets="barChartEffectsDataset"
                     v-bind:show-legend="false" :height="260"/>
          <div v-for="label in barChartEffectsDataset" class="legend-item"><span
              :style="{background:label.backgroundColor}"></span>{{label.label}}
          </div>
        </div>
        <div class="col-md-6 col-sm-12 pt-md-2" v-if="consequenceInBehavior && !isClient">
          <h5>{{'behavior.ub_behavior' | trans }}</h5>
    
          <bar-chart :bardatasets="barChartConsequenceInBehaviorDataset"
                     v-bind:show-legend="false" :height="260"/>
          <div v-for="label in barChartConsequenceInBehaviorDataset" class="legend-item"><span
              :style="{background:label.backgroundColor}"></span>{{label.label}}
          </div>
        </div>

      </div>
    </div>
    
    <div class="col-12 mt-3" v-if="scatterplotData && scatterplotXLabels.length">
      <h4 class="stage-results__title">{{'behavior.scatter_plot' | trans }}</h4>
      <div class="fixed-table-wrapp">
  
        <table class="table table-sm table-bordered">
          <thead class="thead-light">
          <tr>
            <th class="time-cell"></th>
            <th v-for="data in scatterplotXLabels" class="text-center">{{data | toLocaleDate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="time in scatterplotYLabels">
            <th class="text-center">
              {{time.text}}
            </th>
            <td v-for="data in scatterplotXLabels" class="text-center" :class="{'checked-cell': currentScatterplotValue(data, scatterplotData[time.id])}">
              {{currentScatterplotValue(data, scatterplotData[time.id])}}
            </td>
    
          </tr>
          </tbody>
        </table>
      </div>
      
    </div>

  </div>

</template>

<script>
  import apiUndesirableBehavior from '../api/undesirableBehavior';
  import undesirableBehaviorAddModal from './AddModal';
  import editTypicalBehaviorsModal from './editTypicalBehaviorsModal.vue';
  import {pagination} from '../../../common/mixins/pagination';
  import {showModal} from '../../../common/mixins/showModal';
  import {mapState, mapGetters, mapActions} from 'vuex';
  import Loader from '../../loader/components/Loader';
  import isEmpty from 'lodash/isEmpty';
  import cloneDeep from 'lodash/cloneDeep';
  import filter from 'lodash/filter';
  import Constants from '../Constants';
  import moment from 'moment';
  import timezone from 'moment-timezone';
  import lang from '../../../lang/translator';
  import forEach from 'lodash/forEach';
  import orderBy from 'lodash/orderBy';
  import {
    BarChart,
    BarChartDataset,
  } from '../../../common/chart';
  import {LineChart, LineChartDataset} from '../../../common/chart';


  export default {
    props: {
      clientId: null,
      rangeDateStart: null,
      rangeDateEnd: null,
      protocolId: null,
      ancedentId: null,
      behaviorId: null,
      isApplyChanges: false
    },
    data() {
      return {
        activeBehaviorId: null,
        isModalVisible: false,
        isEditModalVisible: false,
        measurements: [],
        antecedentTypes: null,
        consequenceInBehavior: null,
        behaviorTypes: null,
        effectsTypes: null,
        antecedentLegend: null,
        behaviorLegend: null,
        effectsLegend: null,
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        protocolList: [],
        protocol: null,
        disabledSelect: false,
        loading: false,
        lastAncedentId: null,
        ancedents: [{id: "all", text: lang.get('behavior.ancedent')}],
        isLastAncedentPage: false,
        pageBehaviors: 1,
        pageAncedents: 1,
        lastBehaviorsId: null,
        behaviorsList: [{id: "all", text: lang.get('behavior.all_option')}],
        isLastBehaviorsPage: false,
        scatterplotData: [],
        scatterplotXLabels: [],
        scatterplotYLabels: [],
      };
    },

    mixins: [pagination, showModal],

    components: {
      LineChart,
      Loader,
      undesirableBehaviorAddModal,
      editTypicalBehaviorsModal,
      BarChart
    },

    computed: {
      ...mapState('behavior', [
        'behaviors',
        'isLoaded',
        'isAdded',
        'paginateData',
      ]),
      ...mapState(['route']),
      isEmptyBehavior: function() {
        return isEmpty(this.behaviors);
      },
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapGetters('auth', [
        'isMensurationForbidden',
        'isClient',
      ]),
      ...mapState('behavior', [
        'typicalBehaviors',
      ]),
      rangeDateStartTimestamp() {
        return moment(this.rangeDateStart).unix() +
            (Math.abs(this.rangeDateEnd.getTimezoneOffset()) *
                Constants.SECONDS_PER_MINUTE);
      },
      rangeDateEndTimestamp() {
        return moment(this.rangeDateEnd).unix() +
            (Math.abs(this.rangeDateEnd.getTimezoneOffset()) *
                Constants.SECONDS_PER_MINUTE);
      },
      lineChartDataset() {
        return [this.fetchLineDatasetForChart()];
      },
      barChartAncedentDataset() {
        return this.fetchBarDatasetForChart(this.antecedentTypes,
            lang.get('behavior.ancedent'));
      },
      barChartBehaviorDataset() {
        return this.fetchBarDatasetForChart(this.behaviorTypes,
            lang.get('behavior.unwanted_behavior'));
      },
      barChartEffectsDataset() {
        return this.fetchBarDatasetForChart(this.effectsTypes,
            lang.get('behavior.aftermath'));
      },
      barChartConsequenceInBehaviorDataset() {
        return this.fetchBarDatasetForChart(this.consequenceInBehavior,
          lang.get('behavior.aftermath'));
      },
    },

    methods: {

      onSetAncedentSelected(selected){
        this.ancedentId = selected
      },

      onSetBehaviorsSelected(selected){
        this.behaviorId = selected
      },

       toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM');
      },

      fetchLineDatasetForChart() {
        let data = [], i = 0;
        forEach(this.measurements, (item) => {
          data.push(
              {
                x: this.toLocaleDate(item.dateRange.end),
                y: item.perHourCount,
              },
          );
        });

        return new LineChartDataset({
          data,
        });

      },

      getRandomColor() {
        let letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        if (color == '#255255') return '#333333';
        return color;
      },

      fetchBarDatasetForChart(listTypes, name) {
        let data = [], i = 0, label = name, backgroundColor, datasets = [],
            legends = [];

        let types = orderBy(listTypes, 'count', 'desc');

        forEach(types, (item) => {
          data = [
            {
              x: ++i,
              y: item.count,
            },
          ];
          label = item.title;
          backgroundColor = this.getRandomColor();
          legends.push({
            label: label,
            background: backgroundColor,
          });


          datasets.push(new BarChartDataset({
            data, label, labels: legends, backgroundColor, borderColor: backgroundColor,
          }));

        });

        return datasets;
      },

      getDateTimestamp(date) {
        return moment(date).unix() +
            (Math.abs(date.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },

      fetchMeasurement: async function() {
        try {
          await this.getCountBehavior();
          await this.getCountTypes();
          await this.getScatterplotData();
          
        } catch (error) {
          console.dir(error);
        } finally {
          this.$emit('changedView');
        }
      },

      getCountBehavior: async function() {
        
        let response = await apiUndesirableBehavior.getCountBehavior(
            this.clientId,
            this.protocolId,
            this.ancedentId,
            this.behaviorId,
            this.rangeDateStartTimestamp,
            this.rangeDateEndTimestamp,
        );
        this.measurements = response.data.data;
      },

      getCountTypes: async function() {
        
        let responseTypes = await apiUndesirableBehavior.getCountTypes(
            this.clientId,
            this.protocolId,
            this.ancedentId,
            this.behaviorId,
            this.rangeDateStartTimestamp,
            this.rangeDateEndTimestamp,
        );
        this.antecedentTypes = responseTypes.data.data.antecedent;
        this.behaviorTypes = responseTypes.data.data.behavior;
        this.effectsTypes = responseTypes.data.data.effects;
        this.consequenceInBehavior = responseTypes.data.data.consequenceInBehavior;
      },

      getScatterplotData: async function() {

        let response = await apiUndesirableBehavior.getScatterplotData(
          this.clientId,
          this.protocolId,
          this.ancedentId,
          this.behaviorId,
          this.rangeDateStartTimestamp,
          this.rangeDateEndTimestamp,
        );
        this.scatterplotData = response.data.data.statistic;
        this.scatterplotXLabels = response.data.data.dates;
        this.scatterplotYLabels = Constants.scatterplotYLabels;
      },

      currentScatterplotValue(data,value){
      
        let current = filter(value, function(item) { return item.date === data; });
        
        return current.length ? current[0].totalCount : null
      
      },

      getOptionAncedentTitle: function({option}) {
        return option.text;
      },

      getOptionBehaviorsTitle: function({option}) {
        return option.text;
      },
      
    },
    watch: {
      isApplyChanges(newValue){
        if (newValue){
          this.fetchMeasurement();
        }
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/undesirableBehavior/components/UndesirableBehaviorChart.vue